import { manageTabs } from "../home";
import { fillSlider, getEvents } from "../../frameworks/mz-wp-api";
import { tns, TinySliderSettings } from "tiny-slider";

const container = document.currentScript.previousElementSibling;
const tabs = manageTabs(container.querySelector(".tabs"));

/** @returns {TinySliderSettings} */
const sliderOptions = function (sliderContainer) {
    return {
        container: sliderContainer,
        disable: true,
        autoplay: false,
        controls: true,
        controlsPosition: "bottom",
        nav: false,
        mouseDrag: true,
        loop: false,
        fixedWidth: 226,
        responsive: {
            1300: {
                disable: false,
            },
        },
    };
};

function getContainer(sectionClass) {
    return container.querySelector(`.container > .rows .${sectionClass} > .items`);
}

let eventsMissedScheduleds = [];

const sections = {
    live: {
        container: "liveEvents",
        slider: null,
        reqBody: {
            action: "getEventsMultiple",
            status: "all",
            isLive: "true",
            order: "DESC",
        },
        init: function () {
            let container = getContainer(this.container);
            if (container) {
                this.slider = new tns(sliderOptions(container));

                getEvents(this.reqBody).then((res) => {
                    if (this.slider && typeof this.slider.destroy === "function") {
                        this.slider.destroy();
                        this.slider = null;
                        container = getContainer(this.container);
                    }

                    res.posts = res.posts.slice(0, 10);
                    if (fillSlider(res, container) === false) {
                        tabs[0].classList.add("hidden");
                        if (tabs[1].classList.contains("hidden")) {
                            tabs[2].click();
                        } else {
                            tabs[1].click();
                        }
                    } else {
                        tabs[0].classList.remove("hidden");
                    }
                    this.slider = new tns(sliderOptions(container));
                });
            }
        },
    },
    scheduled: {
        container: "nextEvents",
        slider: null,
        reqBody: {
            action: "getEventsMultiple",
            status: "future",
            isLive: "false",
            order: "DESC",
            posts_per_page: 10,
        },
        init: function () {
            let container = getContainer(this.container);
            if (container) {
                this.slider = new tns(sliderOptions(container));
                container.classList.add("loading");

                getEvents(this.reqBody).then((res) => {
                    if (this.slider && typeof this.slider.destroy === "function") {
                        this.slider.destroy();
                        this.slider = null;
                        container = getContainer(this.container);
                    }

                    // let currentDate = new Date(); //Pega a data atual
                    // let arrayFuture = [];
                    // res.posts.map(function (e, i) {
                    //     let eventDateTime = new Date(e.eventDate);
                    //     if (eventDateTime > currentDate) {
                    //         arrayFuture.push(e);
                    //     }
                    // });
                    
                    console.log('res.posts: ', res.posts)
                    let sortedArray = res.posts.sort((a, b) => new Date(b.eventDate) - new Date(a.eventDate));
                    sortedArray.reverse();
                    res.posts = sortedArray.slice(0, 10);
                    console.log('sortedArray: ', res.posts)

                    let eventsArray = res.posts;
                    let arrayNewEvents = [];
                    let currentDateNew = new Date();

                    Date.prototype.addHours = function (h) {
                        this.setHours(this.getHours() + h);
                        return this;
                    };

                    // console.log("eventsArray => ", eventsArray);

                    eventsArray.forEach(function (event, i) {
                        let eventDateNew = new Date(event.eventDate).addHours(3);
                        if (currentDateNew < eventDateNew) {
                            arrayNewEvents.push(event);
                        } else {
                            event.status = "publish";
                            eventsMissedScheduleds.push(event);
                        }
                    });

                    // console.log("arrayNewEvents => ", arrayNewEvents);

                    // console.log("eventsMissedScheduleds => ", eventsMissedScheduleds);

                    res.posts = arrayNewEvents;

                    if (fillSlider(res, container) === false) {
                        tabs[1].classList.add("hidden");
                        tabs[2].click();
                    } else {
                        tabs[1].classList.remove("hidden");
                    }
                    this.slider = new tns(sliderOptions(container));
                });
            }
        },
    },
    past: {
        container: "pastEvents",
        slider: null,
        reqBody: {
            action: "getEventsMultiple",
            status: "publish",
            isLive: "false",
            order: "DESC",
        },
        // reqBody2: {
        //     action: "getEventsMultiple",
        //     status: "all",
        //     isLive: "false",
        //     order: "ASC",
        // },
        init: function () {
            let container = getContainer(this.container);
            if (container) {
                this.slider = new tns(sliderOptions(container));
                container.classList.add("loading");

                getEvents(this.reqBody).then((res) => {
                    if (this.slider && typeof this.slider.destroy === "function") {
                        this.slider.destroy();
                        this.slider = null;
                        container = getContainer(this.container);
                    }
                    let currentDate = new Date();
                    let arrayPast = [];
                    res.posts.map(function (e, i) {
                        let eventDateTime = new Date(e.eventDate);
                        if (currentDate >= eventDateTime) {
                            arrayPast.push(e);
                        }
                    });

                    arrayPast = [...eventsMissedScheduleds, ...arrayPast];

                    let sortedArrayPast = arrayPast.sort((a, b) => new Date(b.eventDate) - new Date(a.eventDate));

                    res.posts = sortedArrayPast.slice(0, 10);

                    // console.log("eventsMissedScheduleds past => ", eventsMissedScheduleds);

                    // console.log("posts past => ", res.posts);

                    fillSlider(res, container, "newestToOldest");

                    this.slider = new tns(sliderOptions(container));
                });
                // getEvents(this.reqBody2).then((res) => {});
            }
        },
    },
};

function renderGalleryEvents() {
    sections.live.init();
    sections.scheduled.init();
    // sections.past.init();
    setTimeout(() => {
        sections.past.init();
    }, 4000);
}

renderGalleryEvents();
